@if (config; as brand) {
  <footer class="bg-footer px-4 pb-8 pt-16 text-white/70 sm:px-6">
    <div class="mx-auto max-w-[1100px]">
      <div class="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          @if (brand.self.logoLight || brand.self.logo) {
            <a routerLink="/" class="focus-ring mb-5 inline-flex" [attr.aria-label]="brand.site.name + ' home'">
              <img
                class="h-12 w-auto max-w-[200px] object-contain object-left"
                [src]="brand.self.logoLight || brand.self.logo"
                [alt]="brand.site.name">
            </a>
          } @else {
            <div class="mb-5 font-display text-xl font-extrabold text-white">{{ brand.site.name }}</div>
          }
          @if (brand.site.operatorAbout) {
            <p class="max-w-xs text-sm leading-6 text-white/55">{{ brand.site.operatorAbout }}</p>
          }
          <div class="mt-5 flex gap-3">
            @if (brand.socialLinks.facebook) {
              <a class="focus-ring inline-flex size-9 items-center justify-center rounded-full bg-white/10 text-white/70 transition hover:bg-white/15 hover:text-white" [href]="brand.socialLinks.facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <span aria-hidden="true" class="font-bold">f</span>
              </a>
            }
            @if (brand.socialLinks.twitter) {
              <a class="focus-ring inline-flex size-9 items-center justify-center rounded-full bg-white/10 text-white/70 transition hover:bg-white/15 hover:text-white" [href]="brand.socialLinks.twitter" target="_blank" rel="noopener noreferrer" aria-label="X">
                <span aria-hidden="true" class="font-bold">X</span>
              </a>
            }
            @if (brand.socialLinks.instagram) {
              <a class="focus-ring inline-flex size-9 items-center justify-center rounded-full bg-white/10 text-white/70 transition hover:bg-white/15 hover:text-white" [href]="brand.socialLinks.instagram" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <span aria-hidden="true" class="text-xs font-bold">IG</span>
              </a>
            }
          </div>
        </div>

        <div>
          <h2 class="mb-4 text-sm font-bold text-white">Company</h2>
          <nav class="flex flex-col gap-2.5" aria-label="Company links">
            <a routerLink="/about-us" class="focus-ring text-sm text-white/70 transition hover:text-white">About us</a>
            <a routerLink="/contact-us" class="focus-ring text-sm text-white/70 transition hover:text-white">Contact us</a>
            <a routerLink="/privacy-policy" class="focus-ring text-sm text-white/70 transition hover:text-white">Privacy policy</a>
            <a routerLink="/terms-and-condition" class="focus-ring text-sm text-white/70 transition hover:text-white">Terms & conditions</a>
          </nav>
        </div>

        <div>
          <h2 class="mb-4 text-sm font-bold text-white">Top routes</h2>
          <nav class="flex flex-col gap-2.5" aria-label="Top routes">
            @for (route of topRoutes; track route.title) {
              <button
                type="button"
                class="focus-ring w-fit border-0 bg-transparent p-0 text-left text-sm text-white/70 transition hover:text-white"
                (click)="searchTopRoute(route)">
                {{ route.description || route.title }}
              </button>
            }
            @if (!topRoutes.length) {
              <a routerLink="/" fragment="search" class="focus-ring text-sm text-white/70 transition hover:text-white">Search available routes</a>
            }
          </nav>
        </div>

        <div>
          <h2 class="mb-4 text-sm font-bold text-white">Contact</h2>
          <div class="flex flex-col gap-2.5">
            @if (brand.site.supportNumber) {
              <a [href]="supportPhoneHref" class="focus-ring break-words text-sm text-white/70 transition hover:text-white">{{ brand.site.supportNumber }}</a>
            }
            @if (brand.site.supportEmail) {
              <a [href]="supportEmailHref" class="focus-ring break-words text-sm text-white/70 transition hover:text-white">{{ brand.site.supportEmail }}</a>
            }
            @if (brand.site.address) {
              <address class="text-sm not-italic leading-6">
                <a
                  [href]="supportMapHref"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="focus-ring text-white/55 transition hover:text-white">
                  {{ brand.site.address }}
                </a>
              </address>
            }
          </div>
        </div>
      </div>

      <div class="mt-12 border-t border-white/10 pt-6 text-center text-xs text-white/45 sm:text-left">
        © {{ year }} {{ brand.site.name }}. All rights reserved.
      </div>
    </div>
  </footer>
}
